var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemainingVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 76,
    height: 76,
    rx: 38,
    fill: "#FFF4F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9998 20.1641C41.3827 20.1641 44.1035 20.1641 46.3232 20.3251L40.0139 29.7891H31.4023L37.819 20.1641H37.9998Z",
    fill: "#DA4505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3513 22.8489C24.6473 20.5529 28.14 20.2204 34.5085 20.1722L28.0972 29.7891H19.8574C20.1274 26.5549 20.7789 24.4213 22.3513 22.8489Z",
    fill: "#DA4505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1421 29.7891C55.8721 26.5549 55.2206 24.4213 53.6482 22.8489C52.5531 21.7538 51.1858 21.1054 49.3641 20.7214L43.319 29.7891H56.1421Z",
    fill: "#DA4505"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.7145 32.5391C19.666 34.2601 19.666 36.23 19.666 38.4974C19.666 47.1398 19.666 51.461 22.3509 54.1458C25.0357 56.8307 29.3569 56.8307 37.9993 56.8307C40.4889 56.8307 47.1625 56.8307 48.999 56.7665C47.3781 56.6599 49.7529 51.75 48.999 50.9961C47.7908 49.7879 48.999 54.8852 48.999 50.9961C47.7908 52.2043 48.999 47.107 48.999 50.9961C45.3727 51.6615 50.2072 49.7879 48.999 50.9961C47.7908 49.7879 52.8881 50.9961 48.999 50.9961C49.753 51.7501 56.1619 47.3749 56.2685 48.9961C56.3327 47.1594 56.3327 40.9871 56.3327 38.4974C56.3327 36.23 56.3327 34.2601 56.2842 32.5391H19.7145Z",
    fill: "#DA4505"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 48.75C56.5 44.1937 52.8063 40.5 48.25 40.5C43.6937 40.5 40 44.1937 40 48.75C40 53.3063 43.6937 57 48.25 57C52.8063 57 56.5 53.3063 56.5 48.75Z",
    fill: "#DA4505"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2508 44.0078C48.5925 44.0078 48.8695 44.2848 48.8695 44.6266V49.5766C48.8695 49.9183 48.5925 50.1953 48.2508 50.1953C47.9091 50.1953 47.632 49.9183 47.632 49.5766V44.6266C47.632 44.2848 47.9091 44.0078 48.2508 44.0078Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2508 52.8766C48.7064 52.8766 49.0758 52.5072 49.0758 52.0516C49.0758 51.5959 48.7064 51.2266 48.2508 51.2266C47.7951 51.2266 47.4258 51.5959 47.4258 52.0516C47.4258 52.5072 47.7951 52.8766 48.2508 52.8766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemainingVideos);
export default __webpack_public_path__ + "static/media/remaining_videos.e5af827921cca052668496d32c2ff80c.svg";
export { ForwardRef as ReactComponent };